var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M10.604 3.146a.5.5 0 0 1 0 .708L6.457 8l4.147 4.146a.5.5 0 1 1-.708.708l-4.5-4.5a.5.5 0 0 1 0-.708l4.5-4.5a.5.5 0 0 1 .708 0z","fill-rule":"evenodd"}})])};var toString = function () {return "/home/jenkins/workspace/b_kiwitaxi-cabinet-client_master/src/assets/icons/chevron-left.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chevron-left.svg
// module id = Gmua
// module chunks = 11